import { ZapState } from "@/domains/minimal-pools-zap/zap-store"

type customIcon = "spinner" | "completed" | "failed" | "voltage" | "onchain-action"

type ZapStep = {
  number: number
  title: string
  key: string
  className: string
  dataContent?: string
  customIcon?: customIcon
}

export const zapStepMap: Record<ZapState, Array<ZapStep>> = {
  idle: [
    { number: 1, title: "Estimate", key: "estimate", className: "step step-neutral step-primary" },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  gettingEstimate: [
    {
      number: 1,
      title: "Estimating",
      key: "estimate",
      className: "step step-neutral step-primary",
      customIcon: "spinner",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  estimated: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-neutral step-success",
      customIcon: "completed",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  estimateFailed: [
    {
      number: 1,
      title: "Estimate",
      key: "estimate",
      className: "step step-neutral step-error",
      customIcon: "failed",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  gettingApprovalStatus: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Checking",
      key: "approve",
      className: "step step-neutral step-primary",
      customIcon: "spinner",
    },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  approvalRequired: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approve",
      key: "approve",
      className: "step step-neutral step-primary",
      customIcon: "onchain-action",
    },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  approving: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approving",
      key: "approve",
      className: "step step-neutral step-primary",
      customIcon: "onchain-action",
    },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  approved: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approved",
      key: "approve",
      className: "step step-neutral step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  approvalFailed: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-neutral step-primary step-success",
      customIcon: "completed",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral step-error", customIcon: "failed" },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral" },
  ],
  executing: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approved",
      key: "approve",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Zap", key: "zap", className: "step step-primary", customIcon: "onchain-action" },
  ],
  completed: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-primary step-success",
      customIcon: "voltage",
    },
    {
      number: 2,
      title: "Approved",
      key: "approve",
      className: "step step-success",
      customIcon: "voltage",
    },
    { number: 3, title: "Zapped", key: "zap", className: "step step-success", customIcon: "voltage" },
  ],
  executionFailed: [
    {
      number: 1,
      title: "Estimated",
      key: "estimate",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approved",
      key: "approve",
      className: "step step-neutral step-primary step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Zap", key: "zap", className: "step step-neutral step-error", customIcon: "failed" },
  ],
}
